import { LayerConfigInterface, StateConfigInterface, ValueOptionsInterface } from './types'

export const VALUE_OPTIONS_DEFAULT_STATE: ValueOptionsInterface = {
    variable: {
        value: 'value',
        fontColor: null,
        isBold: false,
        isItalic: false
    },
    prefix: {
        isEnabled: false,
        value: null,
        fontColor: null,
        isBold: false,
        isItalic: false
    },
    sufix: {
        isEnabled: false,
        value: null,
        fontColor: null,
        isBold: false,
        isItalic: false
    },
    trend: {
        isEnabled: false,
        tooltipMessage: null
    },
    label: {
        isEnabled: false,
        value: null,
        position: 'left',
        fontColor: null,
        isBold: false,
        isItalic: false,
        isIconEnabled: false,
        iconValue: null,
        iconColor: null
    }
}

export const LAYER_DEFAULT_STATE: LayerConfigInterface = {
    name: '',
    mainValue: VALUE_OPTIONS_DEFAULT_STATE,
    secondaryValues: []
}

export const CONFIG_DEFAULT_STATE: StateConfigInterface = {
    isSizeFixed: false,
    valueFormat: null,
    layersConfig: { 0: LAYER_DEFAULT_STATE }
}

export const REDUX_DEFAULT_STATE = {
    events: {},
    loading: true
}

export const LABEL_POSITION_OPTIONS = [
    { label: 'Bottom', value: 'bottom' },
    { label: 'Top', value: 'top' },
    { label: 'Right', value: 'right' },
    { label: 'Left', value: 'left' }
]

export const DEFAULT_FONT_SIZE = '72px'
